import MarkSafe from '../../../../../general/components/MarkSafe';

const Message = ({date, text}) => (
    <li>
        <span className="metar-date">{date}</span>
        <MarkSafe Element="span" className="metar-string" html={text} />
    </li>
);

export default Message;
